// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"174":"919a66fd","453":"ea1ab1d7","605":"79fa59ed","725":"232f031a","809":"fc62e0ea","894":"48b22eb6"}[chunkId] + ".chunk.js";
};